import { get, post } from "./Api";

export function SearchBookingDetails({ params }) {
  return get({ url: `/api/v1/healthland/booking/searchBookingDetails`, params });
}